const React = require("react");
const T = React.PropTypes;

require("./SummaryQuestion.less");

const QuestionType = require("~/types/Question.js").PropType;

const SummaryChecklist = require("../SummaryChecklist/SummaryChecklist.jsx");
const SummaryDropDown = require("../SummaryDropDown/SummaryDropDown.jsx");
const SummaryFreeform = require("../SummaryFreeform/SummaryFreeform.jsx");
const SummaryTable = require("../SummaryTable/SummaryTable.jsx");
const SummaryCauditList = require("../SummaryCauditList/SummaryCauditList.jsx");
const SummaryDateSelector = require("../SummaryDateSelector/SummaryDateSelector.jsx");

//const QuestionStatus = require("../QuestionStatus/QuestionStatus.jsx");

const SummaryQuestion = React.createClass({
    propTypes: {
        SectionIDPath: T.arrayOf(T.string).isRequired,
        Question: QuestionType.isRequired,
        IsReadOnly: T.bool.isRequired
    },
    getInitialState() {
        return {
            QuestionIDPath: this.props.SectionIDPath.concat(this.props.Question.GUID)
        };
    },
    render() {
        const question = this.GetQuestion();

        //const status = this.GetStatus();

        return (<div className="cs-SummaryQuestion">
                <fieldset disabled={this.props.IsReadOnly}>
                    {question}
                </fieldset>
        </div>);
    },
    GetQuestion() {
        switch (this.props.Question.QuestionType.BaseDisplayType) {
            case 1:
                return (<div>Checkbox goes here</div>);
            case 2:
                return (<div>Radiobuttons go here</div>);
            case 3:
                return (<SummaryDropDown Question={this.props.Question} />);
            case 4:
                return (<div>Percent goes here</div>);
            case 5:
                return (<div>Numeric goes here</div>);
            case 6:
                return (<SummaryDateSelector Question={this.props.Question} />);
            case 7:
                return (<SummaryChecklist Question={this.props.Question} />);
            case 8:
                return (<SummaryTable Question={this.props.Question } />);
            case 101:
                return (<SummaryCauditList Question={this.props.Question} />);
            case 0:
            default:
                return (<SummaryFreeform Question={this.props.Question} />);
        }
    }
});

module.exports = SummaryQuestion;


// WEBPACK FOOTER //
// ./src/components/SurveySummary/SummaryQuestion/SummaryQuestion.jsx